import React, { useState, useEffect } from "react";
import DepartmentsMenu from "../DepartmentsMenu/DepartmentsMenu.jsx";
import SearchBar from "../SearchBar/SearchBar.jsx";
import ActionIcons from "../ActionIcons/ActionIcons.jsx";
import MobileMenu from "../MobileMenu/MobileMenu.jsx";
import { SecondaryNav } from "../SecondaryNav/SecondaryNav";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buscarProdutos = (termo) => {
    console.log("Buscando por:", termo);
  };
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); //verifica se a tela é menor que 768px caso seja, ele altera o valor de Ismobile para true
    };

    // Verifica no carregamento inicial da pagina
    handleResize();

    // Atualiza quando a janela for redimensionada, por exemplo quando o user virar o celular na horizontal
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <header className="relative z-50">
      {/* Promo banner */}

      {/* Main navbar */}
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-gray-900 ${isScrolled ? "" : ""
        }`}
      >
        <div className="max-w-full mx-auto px-4 md:px-6">
          <div className="flex items-center justify-around h-20">
            {/* Logo */}
            <div className="flex items-center">
              <Link
                to="/"
                className="flex items-center gap-3 scale-105 transition-all duration-200 transform hover:scale-110 "
              >
                <img
                  src="/Logo-light.png"
                  alt="logo"
                  loading="lazy"
                  className="w-14 md:w-24 lg:w-24 xl:w-16 h-auto mx-auto rounded-lg object-cover"
                />

                {!isMobile && (
                  <h1 className="hidden xl:flex font-serif uppercase font-bold text-white text-xl xl:text-lg 2xl:text-xl tracking-wide">
                    Dominus
                  </h1>
                )}
              </Link>
            </div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center w-full max-w-3xl ml-6 md:ml-0 lg:ml-6 gap-4">
              <DepartmentsMenu />
              <SearchBar onSearch={buscarProdutos} />
            </div>

            {/* Action Icons */}
            <div className="hidden md:flex items-center ml-0 md:ml-10 lg:0">
              <ActionIcons />
            </div>

            {/* Mobile menu button */}
            <div className="flex md:hidden w-fit m-2 items-center">
              <div className="md:hidden">
                <SearchBar onSearch={buscarProdutos} />
              </div>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-white ml-2 p-2 rounded-md bg-transparent border-none cursor-pointer hover:bg-gray-800 focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {mobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Secondary Navigation */}
      <SecondaryNav />

      {/* Mobile menu */}
      {mobileMenuOpen && <MobileMenu setMobileMenuOpen={setMobileMenuOpen} />}
    </header>
  );
};

export default Navbar;
